// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"212":"a02de8c6","945":"a02de8c6"}[chunkId] + ".chunk.css";
};